(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-vzy-faq]';
  const controllers = new WeakMap();
  const pendingObservers = new WeakMap();
  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const setItemState = (item, open) => {
    const button = item.querySelector('.collapsible-content__toggle');
    const answer = item.querySelector('.collapsible-content__answer');
    if (!button || !answer) return;
    item.classList.toggle('active', open);
    button.setAttribute('aria-expanded', String(open));
    answer.hidden = !open;
    answer.removeAttribute('style');
  };

  const enhanceQuestion = (question, index) => {
    if (question.querySelector('.vzy-faq-v2__question-text')) return;
    const label = cleanText(question.textContent).replace(/^\d+[.)]\s*/, '');
    const number = document.createElement('span');
    const text = document.createElement('span');
    number.className = 'vzy-faq-v2__index';
    number.setAttribute('aria-hidden', 'true');
    number.textContent = String(index + 1).padStart(2, '0');
    text.className = 'vzy-faq-v2__question-text';
    text.textContent = label;
    question.replaceChildren(number, text);
  };

  const initFaq = (section) => {
    if (!section || controllers.has(section)) return;
    pendingObservers.get(section)?.disconnect();
    pendingObservers.delete(section);

    const items = [...section.querySelectorAll('.collapsible-content__item')];
    if (!items.length) return;
    const abortController = new AbortController();
    const signal = abortController.signal;
    const sectionKey = `vzy-faq-${section.dataset.vzyFaqSectionId || section.closest('.shopify-section')?.id || 'product'}`;
    controllers.set(section, { abortController });
    section.dataset.vzyFaqReady = 'true';
    section.classList.add('vzy-faq-v2');

    const titles = section.querySelector('.collapsible-content__titles');
    if (titles && !titles.querySelector('.vzy-faq-v2__count')) {
      const count = document.createElement('span');
      count.className = 'vzy-faq-v2__count';
      count.setAttribute('aria-hidden', 'true');
      count.textContent = `${items.length} întrebări`;
      titles.appendChild(count);
    }

    const configuredOpenIndex = items.findIndex((item) => item.classList.contains('active'));
    const initialOpenIndex = configuredOpenIndex >= 0 ? configuredOpenIndex : 0;
    items.forEach((item, index) => {
      const button = item.querySelector('.collapsible-content__toggle');
      const answer = item.querySelector('.collapsible-content__answer');
      const question = item.querySelector('.collapsible-content__question');
      if (!button || !answer || !question) return;
      const buttonId = `${sectionKey}-question-${index + 1}`;
      const answerId = `${sectionKey}-answer-${index + 1}`;
      button.type = 'button';
      if (window.jQuery) window.jQuery(button).off('click');
      button.id = buttonId;
      button.setAttribute('aria-controls', answerId);
      answer.id = answerId;
      answer.setAttribute('aria-labelledby', buttonId);
      answer.setAttribute('role', 'region');
      enhanceQuestion(question, index);
      setItemState(item, index === initialOpenIndex);
    });

    section.addEventListener('click', (event) => {
      const button = event.target.closest('.collapsible-content__toggle');
      if (!button || !section.contains(button)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const currentItem = button.closest('.collapsible-content__item');
      if (!currentItem) return;
      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      items.forEach((item) => setItemState(item, item === currentItem ? willOpen : false));
    }, { capture: true, signal });
  };

  const queueFaq = (section) => {
    if (!section || controllers.has(section) || pendingObservers.has(section)) return;
    if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
      initFaq(section);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      pendingObservers.delete(section);
      initFaq(section);
    }, { rootMargin: '600px 0px', threshold: 0 });
    pendingObservers.set(section, observer);
    observer.observe(section);
  };

  const destroyFaq = (section) => {
    pendingObservers.get(section)?.disconnect();
    pendingObservers.delete(section);
    controllers.get(section)?.abortController.abort();
    controllers.delete(section);
    delete section.dataset.vzyFaqReady;
  };

  const initAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) queueFaq(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(queueFaq);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.(ROOT_SELECTOR)) destroyFaq(event.target);
    event.target.querySelectorAll?.(ROOT_SELECTOR).forEach(destroyFaq);
  });
})();
